import {
    Grid
} from '@material-ui/core'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/pt-br'
import { useContext, useEffect, useState } from 'react'
import { useAuthenticated } from "react-admin"
import ProcessAddActivity from '../../components/process-add-activity'
import { AppContext } from '../../providers/app-context-provider/app.context'
import cookiesProvider from '../../providers/cookies-provider'
import dataProvider from '../../providers/data-provider'
import { getApiUrl } from '../../utils/urls'
import { ProcessActivities } from './process-activities'
import { ProcessAttachments } from './process-attachments'
import { ProcessClient } from './process-client'
import { ProcessDoneBy } from './process-done-by'
import { ProcessHearings } from './process-hearings'
import { ProcessInfo } from './process-info'
import { ProcessParties } from './process-parties'
import { ProcessRecords } from './process-records'
import { ProcessRelatedProcesses } from './process-related'
import { ProfileEnum } from '../../utils/general-profile.enum'

moment.locale('pt-br');

const ProcessDashboard = (props) => {
    useAuthenticated()

    const id = props.match.params.id;
    const context = useContext(AppContext);
    const isStudent = context.profile.name === ProfileEnum.STUDENT

    const [process, setProcess] = useState(undefined)
    const [attachments, setAttachments] = useState(undefined)
    const [canUserInteract, setCanUserInteract] = useState(false)

    useEffect(() => {
        (async () => {
            await dataProvider.getDashboard('processes', { id: id })
                .then(res => {
                    setProcess(res.data)
                    setCanUserInteract([ProfileEnum.ADMIN, ProfileEnum.SUPERADMIN].includes(context.profile.name) || res.data.managed_by.find(el => el.id === context.id))
                })
        })()
    }, [id, context])

    useEffect(() => {
        (async () => {
            const token = cookiesProvider.getToken();
            const url = `${getApiUrl()}/processes/${id}/attachments`
            await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })
                .then(res => {
                    setAttachments(res.data)
                })
        })()
    }, [id])
    return (
        <Grid container spacing={2}>
            <Grid container item spacing={1} direction="row" key={'external'}>
                <Grid container item>
                    <Grid container item xs={5} lg={5} direction='column'>
                    </Grid>
                    <Grid container item spacing={1} xs={7} lg={7} direction='column' key={'controls'}>
                        <Grid container item style={{ paddingInline: '60px 45px' }}>
                            {!isStudent && process && process.active && canUserInteract && <ProcessAddActivity style={{ flexGrow: 1 }} record={process} />}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item>
                    <Grid container item spacing={1} xs={5} lg={5} direction='column' key={'left-column'}>
                        <Grid item key={'process-info'} style={{ marginTop: '28px' }}>
                            {process && <ProcessInfo process={process} isStudent={isStudent} canUserInteract={canUserInteract} />}
                        </Grid>
                        <Grid item key={'related-processes'}>
                            {process && <ProcessRelatedProcesses process={process} isStudent={isStudent} />}
                        </Grid>
                        <Grid item key={'process-records'}>
                            {process && <ProcessRecords process={process} attachments={attachments} isStudent={isStudent} />}
                        </Grid>
                        <Grid item key={'process-hearings'}>
                            {process && <ProcessHearings process={process} />}
                        </Grid>
                        < Grid item key={'process-users'}>
                            {process && <ProcessDoneBy managed_by={process.managed_by} />}
                        </Grid>
                        <Grid item key={'process-client'}>
                            {process && <ProcessClient client={process.client} />}
                        </Grid>
                        <Grid item key={'process-parties'}>
                            {process && <ProcessParties process={process} isStudent={isStudent} canUserInteract={canUserInteract} />}
                        </Grid>
                        <Grid item key={'process-attachments'}>
                            {attachments && <ProcessAttachments attachments={attachments} />}
                        </Grid>
                    </Grid>
                    <Grid container item spacing={1} xs={7} lg={7} direction='column' key={'right-column'}>
                        <Grid item key={'process-activities'}>
                            {process && <ProcessActivities process={process} isStudent={isStudent} />}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}

export default ProcessDashboard;